var map = {
	"./board-basic/list.vue": [
		"c6cf",
		"chunk-2d2178cc"
	],
	"./board-inquiry/list.vue": [
		"31fa",
		"chunk-2d0b948f"
	],
	"./board-notice/list.vue": [
		"7a57",
		"chunk-2d0e1422"
	],
	"./board-question/list.vue": [
		"aa50",
		"chunk-2d212bb1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0d9d";
module.exports = webpackAsyncContext;